import { render, staticRenderFns } from "./itv.vue?vue&type=template&id=6cd4240b&scoped=true&"
import script from "./itv.vue?vue&type=script&lang=js&"
export * from "./itv.vue?vue&type=script&lang=js&"
import style0 from "./itv.vue?vue&type=style&index=0&id=6cd4240b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd4240b",
  null
  
)

export default component.exports